import { getUserInfo } from '../../api/authAPI';

// Instead of a thunk action:
export const fetchUserProfile = async () => {
  // Get the user info directly
  try {
    const userData = await getUserInfo();
    return { type: 'SAVE_PROFILE', payload: userData.user };
  } catch (error) {
    return { type: 'AUTH_FAILURE', payload: error };
  }
};
